/*  */

import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { koalaImg } from "utility/koalaImg";

import { Button } from "antd";
import { Image } from "antd";
import ModalAlert from "components/modal/ModalAlert";
import helper from "services/helper";
import ModalHowToPlay from "./ModalHowToPlay";
import GetCurrentPoint from "../profile/GetCurrentPoint";
import { WordBookAllView } from "services/Api/Module/WordBook";
import { RightOutlined, LeftOutlined, HomeFilled, ArrowLeftOutlined } from '@ant-design/icons';
import heart from "../../assets/imgage/wordBook/ico-heart.svg"

const WordBookAll = () => {
    const [openPopup, setOpenPopup] = useState(false);
    const [openHowToPlay, setOpenHowToPlay] = useState(false);
    const [tootip, setTootip] = useState(false);
    const navigate = useNavigate();
    const stateProfile = useSelector((state) => state.profile.dataUser);
    const stateCurrentPoint = useSelector((state) => state.currentPoint);
    const redeemHeart = stateCurrentPoint.redeemHeart;
    const newCurrentHeart = redeemHeart ? 10 : stateCurrentPoint.currentHeart;
    const customerId = stateProfile.id;
    const [wordBookData, setWordBookData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(0);
    const limit = 20;


    useEffect(() => {
        fetchWordBookView();
        document.documentElement.scrollTop = 0;
    }, [currentPage]);

    const getWordBookView = async () => {
        let _return = {
            status: false,
            result: {},
            rowCount: 0,
        };
        try {
            console.log(currentPage)
            const { data } = await WordBookAllView({
                data: { customer: customerId, limit: limit, offset: (limit * (currentPage - 1)) }
            });
            if (data.resultCode === "20000") {
                const resData = data.resultData;

                _return.status = true;
                _return.result = resData;
                _return.rowCount = data.rowCount;
            } else {
                navigate("/word-book-main");
            }
        } catch (e) {
            console.log(e);
            return _return;
        }
        return _return;
    };

    const fetchWordBookView = async () => {
        try {
            const resData = await getWordBookView();
            setWordBookData(resData.result);
            const check = resData.rowCount / limit
            setLastPage(Math.ceil(check))
        } catch (err) {
            console.log(err);
        }
    };

    const onClickPreviuos = async () => {
        try {
            const old = currentPage
            setCurrentPage(old - 1)
        } catch (err) {
            console.log(err);
        }
    };

    const onClickNext = async () => {
        try {
            const old = currentPage
            setCurrentPage(old + 1)
        } catch (err) {
            console.log(err);
        }
    };



    return (
        <div>
            <GetCurrentPoint />
            <Helmet>
                <title>โคอะลา มาร์ช</title>
                <meta name="title" content="โคอะลา มาร์ช" />
                <meta name="description" content="" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="โคอะลา มาร์ช" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="" />
            </Helmet>

            <div id="pageWordBookAll">
                {/* <!-- Content Page --> */}
                <main>
                    <div className="wrapContent">
                        <div className="bTop">
                            <div style={{display:'flex' , marginTop:'5px'}}>
                                <a className="btnGoBack" onClick={() => navigate('/word-book-main')}>
                                </a>
                                <a className="btnGoHome" onClick={() => navigate('/profile')}>
                                </a>
                            </div>

                            <div className="divHeart">
                            <Image preview={false} src={heart}></Image>
                                <span>{newCurrentHeart}/10</span>
                                <a className="iconInfo" onClick={() => setTootip(true)}></a>
                                <div className="bTips" style={{ display: tootip ? 'block' : 'none' }} >
                                    <a className="btnCloseTips" onClick={() => setTootip(false)}></a>
                                    <p className="bold">เก็บหัวใจครบ 10 ดวง <br></br>เพื่อแลกของรางวัล</p>
                                    <p>
                                        เก็บสะสม Wordbook จากการสแกน สะสมคะแนน เพื่อตอบคำถามในกิจกรรม ตอบ 1 คำถาม รับไปเลย 1 ดวง!
                                    </p>
                                </div>
                            </div>
                        </div>
                        <section id="pWordBook">
                            <div className="pContent">
                                {wordBookData && wordBookData.map((item, index) => {
                                    return (
                                        <div>
                                            <div className="wordCount" hidden={item.count <= 1}> {item.count}</div>
                                            <Image preview={false} src={item.img}></Image>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="pPaging">
                                <button className="btnPrevious" disabled={currentPage === 1}
                                    onClick={() => onClickPreviuos()}
                                ><LeftOutlined /></button>
                                <p>{currentPage}/{lastPage}</p>
                                <button className="btnNext" disabled={currentPage === lastPage}
                                    onClick={() => onClickNext()}
                                ><RightOutlined /></button>
                            </div>
                        </section>

                    </div>
                </main>
            </div >
            <ModalAlert
                open={openPopup}
                title='title'
                subTitle='subTitle'
                content='content'
                onClose={() => setOpenPopup(false)}
            />
            <ModalHowToPlay
                isOpen={openHowToPlay}
                onClose={() => setOpenHowToPlay(false)}
            />
        </div >
    );
};

export default WordBookAll;
